module.exports = require("react-redux");


//////////////////
// WEBPACK FOOTER
// external "react-redux"
// module id = 12
// module chunks = 0